import { eventsList } from '../../events/list';
import { CorrelationId } from '../../utils/CorrelationId';
import { initHttp } from '../../utils/http';
import { extendDeep } from '../../utils/utils';
import { addEvents } from '../decorators';
import { initSearch } from './init-search';
import { defaultSettings } from './settings';
export function MultiSearch(userSettings) {
  if (userSettings === void 0) {
    userSettings = {};
  }
  this.siteMediaToken = userSettings.siteMediaToken;
  const settings = extendDeep(userSettings.metaSiteToken ? {
    requestOptions: {
      headers: {
        Authorization: userSettings.metaSiteToken
      }
    }
  } : {}, defaultSettings, userSettings);
  const correlationId = new CorrelationId();
  const http = initHttp(settings.requestOptions);
  const search = initSearch(settings, http);
  this.name = 'multiSearch';
  this.correlationId = correlationId;
  this.search = addEvents(this, eventsList.MULTI_SEARCH.SEARCH, search);
}